import { fetchUtils, GET_MANY } from "react-admin";

const initEmployeesProvider = (apiUrl, httpClient = fetchUtils.fetchJson, defaultCrudHandler) => {
    return (type, resource, params) => {
        switch (type) {
            case GET_MANY:
                const promises = params.ids.map(id =>
                    httpClient(`${apiUrl}/${resource}/${id}`)
                );
                return Promise.all(promises).then(responses => {
                    return {
                        data: responses.map(response => response.json),
                    };
                });
        
            default:
                console.log("default")
                return defaultCrudHandler(type, resource, params);
        }
    }
};

export default initEmployeesProvider;